import React from "react";
import { GroupedSection } from "../../util/privacy-policies";

import { Container } from "@mui/material";
import { Title } from "@plataformaxvia/design-system";
import { ContentWrap, PrivacyPoliciesWrap, Subtitle } from "./style";
import { HeaderTitle } from "../HeaderTitle/HeaderTitle";

export type PrivacyPoliciesProps = {
  privacyPolicies: GroupedSection[];
};

function getSizeTitle(sort: number): "medium" | "large" {
  if (sort < 1) return "large";
  return "medium";
}

export const PrivacyPolicies: React.FC<PrivacyPoliciesProps> = ({
  privacyPolicies,
}) => {
  return (
    <>
      <HeaderTitle title="Termos de Uso e Políticas de Privacidade" />
      <PrivacyPoliciesWrap>
        <Container>
          {privacyPolicies.map((section, i) => (
            <div key={section.sectionTitle}>
              <Title
                title={`${i > 0 ? `${i}.` : ""} ${section.sectionTitle}`}
                size={getSizeTitle(i)}
              />
              {section.items.map((item, idx) => (
                <ContentWrap key={idx}>
                  {item.subTitle && (
                    <Subtitle>{`${i > 0 ? `${i}.${idx + 1}` : ""} ${
                      item.subTitle
                    }`}</Subtitle>
                  )}
                  <div dangerouslySetInnerHTML={{ __html: item.content }} />
                </ContentWrap>
              ))}
            </div>
          ))}
        </Container>
      </PrivacyPoliciesWrap>
    </>
  );
};
